import { Button, NoData, Pending } from '@finbeat/react-toolkit';
import { deleteContractFile, downloadContractFile } from 'axios/merchantApi';
import FileSaver from 'file-saver';
import useApi from 'hooks/useApi';
import { ContractFile } from 'models/api/merchant';
import { Dispatch, SetStateAction, useState } from 'react';
import { FaFileAlt, FaRegFilePdf, FaTrashAlt } from 'react-icons/fa';
import { useMutation, useQuery } from 'react-query';

type MerchantOrderContractFileProps = {
    contractFilesFetching: boolean;
    fileId: number | null;
    color: string;
    btnName: string;
    canBeDeleted?: boolean;
    className?: string;
    setFileId?: Dispatch<SetStateAction<number | null>>;
    fileType: string;
};

const MerchantOrderContractFile = ({
    color,
    btnName,
    fileId,
    contractFilesFetching,
    className,
    setFileId,
    canBeDeleted = false,
    fileType,
}: MerchantOrderContractFileProps) => {
    const api = useApi();

    const [contractFile, setContractFile] = useState<ContractFile | null>(null);

    const contractFileQuery = useQuery(
        ['merchantContractFile', fileId],
        () => downloadContractFile(api, fileId),
        {
            onSuccess: (data) => setContractFile(data),
            enabled: !contractFilesFetching && !contractFile,
        }
    );

    const downloadContract = () =>
        contractFile && FileSaver.saveAs(new Blob([contractFile.src]), contractFile.filename ?? '');

    const deleteMutation = useMutation({
        mutationFn: () => deleteContractFile(api, fileId),
        onSuccess: () => setFileId && setFileId(null),
    });

    if (contractFilesFetching || contractFileQuery.isFetching) return <Pending />;

    if (!contractFile) return <NoData />;

    return (
        <Button
            color={color}
            className={`w-100 h-75 ${className}`}
            disabled={deleteMutation.isLoading}
            onClick={downloadContract}
        >
            {fileType === 'contract' ? <FaRegFilePdf /> : <FaFileAlt />}
            &nbsp;{btnName}&nbsp;
            {canBeDeleted && (
                <FaTrashAlt
                    onClick={(e) => {
                        e.stopPropagation();
                        deleteMutation.mutate();
                    }}
                />
            )}
        </Button>
    );
};

export default MerchantOrderContractFile;
